export default {"src":"/_next/static/media/caret-right.0e3df5de.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};